export default process.env.ENV || process.env.NODE_ENV;
